"use client";
import { useState } from "react";
import { Password } from "./Password";
import { SignUp } from "../SignUp";
import { SignIn } from ".";
import { useToastify } from "app/hooks/useToastify";
import { validaEmail } from "functions";
interface passwordProps {
  passwordKey: any;
  changePassword: any;
  codeValidate: any;
  saveCode: any;
  savePassword: any;
  handleRedirectLogin: any;
}

export default function Index({
  passwordKey,
  changePassword,
  codeValidate,
  saveCode,
  savePassword,
  handleRedirectLogin,
}: passwordProps) {
  const [isLoading, setIsLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [step, setStep] = useState(1);

  const toast = useToastify();

  const sendEmail = async () => {

    if (email.trim().length == 0) {
      toast.show("warning", "Informe o e-mail")
    }

    if (validaEmail(email)) {
      try {
        setIsLoading(true);

        let response: any = await changePassword(email);

        if (response.status === 204) {
          setStep(2);
        } else {
          toast.show("error", response?.data?.message ?? "Não foi possível solicitar a recuperação de senha.")
        }

      } catch (error: any) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    } else {
      toast.show("warning", "Informe um e-mail válido")
    }
  };

  const backHome = () => {
    handleRedirectLogin();
  };

  return (
    <div className="tw-flex tw-flex-col tw-mx-auto tw-w-full tw-py-[80px] tw-px-[80px]">
      <div className="tw-border-[#151A25] tw-border tw-px-5 tw-py-10 tw-my-auto tw-h-full tw-max-h-[860px] tw-w-full tw-text-xl tw-bg-white tw-shadow-lg tw-rounded-[48px] max-lg:tw-px-[20px] tw-max-w-[596px] tw-mx-auto">
        {step == 1 ? (
          <Password.Root
            className="tw-px-[20px] lg:tw-px-[32px] xl:tw-px-[60px] 2xl:tw-px-[80]px tw-gap-[80px]"
          >
            <div className="tw-self-start tw-flex tw-flex-col tw-w-full">
              <SignUp.Title text={"Redefinir senha"} />
              <SignUp.Subtitle
                text={
                  "Digite seu e-mail, enviaremos o link para redefinição da sua senha."
                }
              />
              <SignIn.Input
                className="mt-12"
                value={email}
                type="text"
                name="recoverInfo"
                placeholder="E-mail"
                onChange={(e) => setEmail(e.target.value)}
              />

              <div className="tw-flex tw-flex-col tw-mt-10 tw-w-full">
                <SignIn.Action
                  id="checkUser"
                  onClick={sendEmail}
                  text="Enviar"
                  className={`tw-self-end tw-mt-20 tw-items-center tw-text-center tw-p-2.5 tw-w-full tw-text-white tw-rounded-lg tw-shadow-sm ${
                    !isLoading
                      ? "tw-bg-[linear-gradient(90deg,#E13441_0%,#FAAE2E_100%)]"
                      : "tw-bg-gray-400"
                  }`}
                  disabled={isLoading}
                />
                <SignIn.Action
                  id="back"
                  onClick={backHome}
                  text="Voltar"
                  className="tw-self-end tw-items-center tw-p-2.5 tw-mt-6 tw-text-center tw-w-full tw-text-red-400 tw-rounded-lg tw-border tw-border-red-400 tw-border-solid"
                  disabled={isLoading}
                />
              </div>
            </div>

          </Password.Root>
        ) : step == 2 ? (
          <Password.Root
            className="tw-px-[20px] lg:tw-px-[32px] xl:tw-px-[60px] 2xl:tw-px-[80]px tw-gap-[80px]"
          >
            <div className="tw-self-start tw-flex tw-flex-col tw-w-full">
              <SignIn.Title
                text={"Redefinir Senha"}
                className="tw-text-left tw-mt-2"
              />
              <SignIn.Subtitle
                className="tw-text-left tw-text-2xl mt-16 font-medium"
                text={
                  "Enviamos um link para redefinição de senha para o seu e-mail. Confira sua caixa de entrada :)"
                }
              />
            </div>
            <div className="tw-self-end tw-tw-mt-10 tw-flex tw-flex-col tw-w-full">
              <SignIn.Action
                id="checkUser"
                onClick={backHome}
                text="Ok"
                className={`tw-self-end tw-mt-10 tw-items-center tw-text-center tw-p-2.5 tw-w-full tw-text-white tw-rounded-lg tw-shadow-sm ${
                  !isLoading
                    ? "tw-bg-[linear-gradient(90deg,#E13441_0%,#FAAE2E_100%)]"
                    : "tw-bg-gray-400"
                }`}
                disabled={isLoading}
              />
            </div>
          </Password.Root>
        ) : (
          ""
        )}
      </div>
    </div>
  );
}
